import React from "react";
import { Card, Button } from "react-bootstrap";
import { CgFileDocument } from "react-icons/cg";
import { BsGithub, BsDisplay } from "react-icons/bs";
import { MdOutlineScreenShare } from "react-icons/md";
import { useTranslation } from "react-i18next"; 

// Ajout de la prop 'priority' envoyée par le parent
function ProjectCards({ imgPath, title, technologies, description, links, projectLink, ghLink, beamerLink, demoLink, priority }) {
  const { t, i18n } = useTranslation(); 
  const isEnglish = i18n.language === "en";
  const iconStyle = { marginBottom: "3px", verticalAlign: "middle" };

  const reportButtons = [];
  if (links) {
    if (links.fr) reportButtons.push({ lang: 'fr', label: isEnglish ? "Report (FR)" : "Rapport (FR)", href: links.fr });
    if (links.en) reportButtons.push({ lang: 'en', label: isEnglish ? "Report (EN)" : "Rapport (EN)", href: links.en });
    reportButtons.sort((a) => (a.lang === i18n.language ? -1 : 1));
  } else if (demoLink) {
    reportButtons.push({ lang: 'fr', label: isEnglish ? "Report (FR)" : t("projects.view_report"), href: demoLink });
  }

  return (
    <Card className="project-card-view">
      {/* OPTIMISATION CRUCIALE ICI */}
      <Card.Img 
        variant="top" 
        src={imgPath} 
        alt="card-img" 
        // 1. Empêche le décalage de mise en page (CLS)
        style={{ aspectRatio: "16/9", objectFit: "cover" }}
        // 2. Charge immédiatement si c'est une des premières cartes, sinon attend le scroll
        loading={priority ? "eager" : "lazy"}
        // 3. Indique au navigateur que cette image est prioritaire pour le CPU/Réseau
        fetchPriority={priority ? "high" : "low"}
        // 4. Décodage asynchrone pour ne pas bloquer le thread principal
        decoding="async"
      />
      
      <Card.Body className="d-flex flex-column">
        <Card.Title>{title}</Card.Title>

        <div className="tech-stack-container">
          {technologies && technologies.map((tech, idx) => (
            <span key={idx} className="tech-badge-project">{tech}</span>
          ))}
        </div>

        <Card.Text className="text-justify mt-3">{description}</Card.Text>

        <div className="mt-auto pt-3">
          <div className="d-flex flex-wrap justify-content-center gap-3">
            {reportButtons.map((btn, idx) => (
              <Button key={idx} variant="primary" href={btn.href} target="_blank">
                <CgFileDocument style={iconStyle} /> &nbsp; {btn.label}
              </Button>
            ))}

            {beamerLink && (
              <Button variant="primary" href={beamerLink} target="_blank">
                <MdOutlineScreenShare style={iconStyle} /> &nbsp; {t("projects.view_beamer")}
              </Button>
            )}

            {projectLink && (
              <Button variant="primary" href={projectLink} target="_blank">
                <BsDisplay style={iconStyle} /> &nbsp; {t("projects.view_project")}
              </Button>
            )}

            {ghLink && (
              <Button variant="primary" href={ghLink} target="_blank">
                <BsGithub style={iconStyle} /> &nbsp; {t("projects.source_code")}
              </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;